module.exports = __webpack_public_path__ + "static/aashay-9f4b8372be1fe627dbb13484c1a734ec.jpg";